import {Routes} from '@angular/router';
import {BlankComponent} from './layouts/blank/blank.component';
import {FullComponent} from './layouts/full/full.component';
import { authChildGuard, authGuard, guestGuard } from './guards/auth.guard';
import { environment } from '../environments/environment';

export const routes: Routes = [
  ...(environment.envName === 'local' ? [
    { path: 'local/repair-preview', loadComponent: () => import('./local-preview/repair-preview.component').then(m => m.RepairPreviewComponent) },
    { path: 'local/repair-preview/shipment/:uuid', data: { shipmentPreview: true }, loadComponent: () => import('./local-preview/repair-preview.component').then(m => m.RepairPreviewComponent) }
  ] : []),
  {
    path: '',
    component: FullComponent,
    canActivate: [authGuard],
    canActivateChild: [authChildGuard],
    children: [
      {
        path: '',
        redirectTo: '/dashboard/home',
        pathMatch: 'full',
      },
      {
        path: 'starter',
        loadChildren: () =>
          import('./pages/pages.routes').then((m) => m.PagesRoutes),
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./pages/dashboard/dashboard.routes').then(
            (m) => m.DashboardsRoutes
          ),
      },
      {
        path: 'management',
        loadChildren: () =>
          import('./pages/management/management.routes').then(
            (m) => m.ManagementRoutes
          ),
      },
      {
        path: 'my-acount',
        loadChildren: () =>
          import('./pages/my-acount/my-acount.routes').then(
            (m) => m.MyAcountRoutes
          ),
      }
    ],
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        canActivate: [guestGuard],
        loadChildren: () =>
          import('./pages/authentication/authentication.routes').then(
            (m) => m.AuthenticationRoutes
          ),
      }
    ],
  },
  {
    path: '**',
    redirectTo: 'authentication/login',
  },
];
